import { $http } from '../request'
import domainConfig from '../../server-config/domain.config'
import qs from 'qs'

export const getProductDetailById = (
  listingId: number,
  type?:string,
  loading:boolean=true,
  isServer: boolean = true
) =>
  $http.get({
    url: `/product/${listingId}`,
    params: { type },
    server: true,
    loading
  }).then((r: any) => r?.data)

export const getSkuDetailById = (
  skuId: number,
  activityId: number | string,
  source: number = 1,
  loading:boolean=true
) =>
  $http.get({ 
    url: `/sku/${skuId}`,
    params: { source, activityId },
    server: true,
    loading
  }).then((r: any) => r.data)

export const getInventoriesById = (listingId: number, addressId: number | '' = '', type: any='', server: boolean = true) =>
  $http.get({ url: `/product/${listingId}/inventories`, params: { type, addressId }, server }).then((r: any) => r?.data)

export const wishListing = (
  listingId: number,
  internalLatestTrafficSourceModule: string,
  internalLatestTrafficSourceType: string,
  insideLatestTrafficSourceValue: string,
  isAd: boolean,
  isNewTag: boolean = false,
  requestId: string = '',
  internalFirstTrafficSourcePage: string = '',
  internalLatestTrafficSourcePage: string = '',
  isChoiceTag: boolean = false
) =>
  $http.post({
    url: '/wish/listings',
    body: {
      listingId,
      internalLatestTrafficSourceModule,
      internalLatestTrafficSourceType,
      insideLatestTrafficSourceValue,
      internalFirstTrafficSourcePage,
      internalLatestTrafficSourcePage,
      isAd,
      isNewTag,
      isChoiceTag,
      requestId
    }
  })

export const delWishListing = (
  listingId: number,
  internalLatestTrafficSourceModule: string,
  internalLatestTrafficSourceType: string,
  insideLatestTrafficSourceValue: string,
  isAd: boolean,
  internalFirstTrafficSourcePage: string = '',
  internalLatestTrafficSourcePage: string = ''
) =>
  $http.delete({
    url: '/wish/listings',
    body: {
      listingId,
      internalLatestTrafficSourceModule,
      internalLatestTrafficSourceType,
      insideLatestTrafficSourceValue,
      internalFirstTrafficSourcePage,
      internalLatestTrafficSourcePage,
      isAd
    }
  })

export interface ISkuItemParams {
  sku: number,
  count: number,
  activityId: number,
  activityType: number,
  authorCode?: any
  referCode?: any
  referSource?: any
  referSourceId?: any,
  internalLatestTrafficSourceModule?: any,
  internalLatestTrafficSourceType?: any,
  insideLatestTrafficSourceValue?: any,
  internalFirstTrafficSourcePage?: string,
  internalLatestTrafficSourcePage?: string,
  isAd?: boolean,
  isNewTag?: boolean,
  isChoiceTag?: boolean,
  requestId?: string
  algorithmModelName?: string
}
export interface IReferParams {
  authorCode?: string
  referCode?: string
  referSource?: string
  referSourceId?: number | ''
}
export type IAddCartParams = ISkuItemParams | IReferParams
export const addCartItem = (params: IAddCartParams) => {
  if(!useUserInfo().value?.accessToken) {
    useRouter().push('/login?redirect=' + useRoute().fullPath)
    return Promise.reject(new Error('请先登录'))
  }

  return $http.post({ url: '/cart-item', params, server: false, loading: true }).then((r: any) => r)
}

/**
 * 获取时效配置
 * @param {*} regionCode 国家CODE
 * @param {*} warehouseId 仓库ID
 * @param {*} userArea { id: xx, area: 'xxx' }
 * @returns 配置列表
*/
export const getDeliveryWarehouseToCdn = async(
  regionCode: string,
  warehouseId: number,
  userArea: Address.IAreaName | null,
  shippingType: number,
  storeShippingAddress?: string
): Promise<ProductV2.IDelivery | undefined> => {
  const cdnConfigResult = await $http.get({
    url: `${domainConfig.EBES_B2C_AWS_S3_OFS_URL}/${regionCode}/map.json`,
    loading: false,
    server: false
  })

  const { timeStamp, fileUrl } = cdnConfigResult || {}
  const currentCacheVersion = useCookie<string>('deliverWarehouseCndVersion')
  const newVersion = `${regionCode}${warehouseId}_${timeStamp}`
  let deliverWarehouse = JSON.parse(localStorage.getItem('deliverWarehouseCndCatch') || '{}')

  if (!currentCacheVersion || newVersion !== currentCacheVersion.value) {
    const deliverWarehouseResult = await $http.get({
      url: fileUrl,
      loading: false,
      server: false
    })
    

    localStorage.setItem('deliverWarehouseCndCatch', JSON.stringify(deliverWarehouseResult))
    deliverWarehouse = deliverWarehouseResult
  }
  currentCacheVersion.value = newVersion

  let { data, template, defaultShortest } = deliverWarehouse

  let wdtStr = userArea ? data[warehouseId] : defaultShortest[warehouseId]
  
  if (!wdtStr) { return }

  const wdt = wdtStr.split('|')

  const [warea, isInternational] = wdt[0].replace(/\[|\]/g, '')
    .split(',')

  let areaId = userArea?.id
  let uArea = userArea?.name
  let areaName = ''
  // 未登录或没有地址时取默认时效
  if(!areaId) {
    areaId = Number(wdt[1].split(':')[0])
    uArea = wdt[2].split(',').pop()
    areaName = wdt[2]
  }
  
  const delivery: ProductV2.IDelivery = {
    postage: 0,
    isInternational: Number(isInternational) === 1,
    areaName, 
    info: []
  }
  // DS 使用店铺发货地（storeShippingAddress）
  template = template.replace('wh_area', storeShippingAddress || warea).replace('auth_area', uArea)
  const currentAddrDelivery = wdt.find((c: string) => c.indexOf(String(areaId)) >= 0)

  if (currentAddrDelivery) {
    const logisticsInfoStr = currentAddrDelivery.split(':')[1].replace(/\[|\]/g, '')
    const [postage, defaultAging, shippingTypeAgingStr] = logisticsInfoStr.split(',')
    const agingShippingTypeMap: { [key: string]: string }  = {} 

    if(shippingTypeAgingStr) {
      shippingTypeAgingStr.split('&').forEach((s: string) => {
        const [type, val] = s.split('=')
  
        agingShippingTypeMap[type] = val
      })
    }

    delivery.postage = Number(postage)
    template = template.replace('delivery_time', agingShippingTypeMap[shippingType] || defaultAging)
  }

  delivery.info.push(template)

  return delivery
}

export interface IVoucherParmas {
  skuIds: number[];
  categoryId: number;
  storeId: number;
  listingId: number;
}
export const getVouchersBySkuids = (params: IVoucherParmas) => $http.get({
  url: '/sku-vouchers',
  params,
  transform: (dt: any) => qs.stringify(dt)
}).then((r: any) => r.data)

export const getGiftsBySkuId = (skuId: number) => $http.get({
  url: `/sku-gifts?saleSkuId=${skuId}`
}).then((r: any) => r.data)

/** New listing API --- START */
/** 获取商品详情基础信息 */
export const getListingById = (params: { productId?: number | string, skuId?: number | string, source?: 0 | 1 } ) =>
    $http.get({ url: '/newproduct', params, server: true }).then((r: any) => r.data)

export const getListingByIdV2 = (params: {
    productId?: number | string,
    skuId?: number | string,
    source?: 0 | 1,
    traffic_source_tracking?: string
}, toastError: boolean = true, headers: Record<string, string> = {}) => {
  const requestParams: IAnyObject = {
    sku_id: params.skuId || '',
    listing_id: params.productId || '',
    activity_type: params.source
  }

  if (params.traffic_source_tracking) {
    requestParams.traffic_source_tracking = params.traffic_source_tracking
  }

  return $http.get({
    url: '/goods-detail',
    params: requestParams,
    server: true,
    toastError,
    headers
  })
    .then((r: any) => r.data)
}

const GOODS_DETAIL_NOT_FOUND_CODES = new Set([5004, 40000])

export type GoodsDetailFailureKind = 'not-found' | 'rate-limited' | 'unexpected'

export interface GoodsDetailFailure {
  kind: GoodsDetailFailureKind
  code?: number
  statusCode: 404 | 429 | 500
  expected: boolean
}

const toFiniteNumber = (value: unknown): number | undefined => {
  if(value === null || value === undefined || value === '') {
    return undefined
  }

  const numericValue = Number(value)
  return Number.isFinite(numericValue) ? numericValue : undefined
}

const getFirstFiniteNumber = (...values: unknown[]): number | undefined => {
  for(const value of values) {
    const numericValue = toFiniteNumber(value)
    if(numericValue !== undefined) {
      return numericValue
    }
  }

  return undefined
}

export const getGoodsDetailErrorCode = (error: any): number | undefined => {
  return getFirstFiniteNumber(
    error?.code,
    error?._data?.code,
    error?.data?.code,
    error?.response?._data?.code
  )
}

const getGoodsDetailHttpStatus = (error: any): number | undefined => {
  return getFirstFiniteNumber(
    error?.status,
    error?.statusCode,
    error?.response?.status,
    error?.response?.statusCode
  )
}

export const classifyGoodsDetailFailure = (error: any): GoodsDetailFailure => {
  const code = getGoodsDetailErrorCode(error)
  const httpStatus = getGoodsDetailHttpStatus(error)

  if(code === 1015 || httpStatus === 429) {
    return { kind: 'rate-limited', code, statusCode: 429, expected: true }
  }

  if(code !== undefined && GOODS_DETAIL_NOT_FOUND_CODES.has(code)) {
    return { kind: 'not-found', code, statusCode: 404, expected: true }
  }

  return { kind: 'unexpected', code, statusCode: 500, expected: false }
}

export const isExpectedGoodsDetailFailure = (error: any): boolean => {
  return classifyGoodsDetailFailure(error).expected
}

export const getInventoryBySkuId = (
  skuId: number,
  params?: { activity_type?: number, activate_id?: number | string }
) => $http.get({ url: `/skus/${skuId}/overview`, params }).then((r: any) => r.data)

/** 通过 Listing ID 获取可用的 SKU 列表 */
export const getSkusById = (listingId: number, source: 0 | 1 = 0) => $http.get({ url: '/goods_detail_skus', params: { listing_id: listingId, source }, server: true }).then((r: any) => r.data)
/** 通过 Base Category ID 获取全路径及类目名称 */
/** 通过 Base Category ID 获取全路径及类目名称 */
export const getCtgPathByCid = (cid: number, server: boolean = true) => $http.get({ url: `/category/${cid}/path`, server }).then((r: any) => r.data)
/** SKU 价格 及 SKU 活动信息 */
export const getSkuPriceBySid = (skuId: number, source: 0 | 1=0, server: boolean = false) => $http.get({ url: `/skuPrice/${skuId}?source=${source}`, server }).then((r: any) => r.data)
/** 商品详情 */
export const getListingDescription = (listingId: number) => $http.get({ url: '/listing_description', params: { listing_id: listingId } }).then((r: any) => r.data)
/** 是否收藏 */
export const getIsWishById = (listingId: number) => $http.get({ url: '/listing_in_wish_list', params: { listing_id: listingId } }).then((r: any) => r.data)
/** 促销活动信息 */
export const getProductPromotion = (params: { productId?: number | string, skuId?: number | string }) => $http.get({ url: '/productPromotion', params }).then((r: any) => r.data)
/** 获取 SKU 服务信息 （已废弃） */
export const getSkuService = (params: { productId?: number | string, skuId?: number | string }, server: boolean = true) => $http.get({ url: '/skuService', params, server }).then((r: any) => r.data)
/** 大促商品 */
export const getBigPromotionListingByBid = (bid: number, skip: number, limit: number) => $http.get({ url: `/promotion/${bid}/listings`, params: { skip, limit }, server: true }).then((r: any) => r.data)
/** 跨店满减提示信息 */
export const getPromotionTipsById = (id: number) => $http.get({ url: `/promotion/${id}/cart`, server: true }).then((r: any) => r.data)
/** New listing API --- END */

interface shippingTimeParams {
  listingId: number,
  skuId? : number,
  skuCount?: number,
  storeId?: number,
  deliveryAreaId?: number,
  logisticsType?: 'gs' | 'ds' | 'fbk',
  shippingType?: number,
  warehouseId?: number
}
/** 时效 */export const getShippingTime = (params: shippingTimeParams) => $http.get({ url: `/logistics/shipping-time`, params}).then((r: any) => r.data)


export const getCategoryPathById = (id: number) => $http.get({ url: `/category/${id}/path` }).then((r: any) => r.data)
export const getFrontCategoryPathById = (id: number) => $http.get({ url: `/front-category/${id}/path` }).then((r: any) => r.data)
export interface ISubscriptionParams { source_type: 1 | 2 |3 /* 1.签到；2.秒杀提醒；3.到货提醒 */, is_subscribe: boolean, session_id?: number, activity_id?: number, sku_id: number }
export const putSubscription = (params: ISubscriptionParams) => $http.put({ url: `/subscription`, body: params }).then((r: any) => r.data)

/** Google 结构化数据 */
export const getGoodsGoogleStructuredData = (params: {
  listing_id?: number,
  sku_id?: number,
  delivery_area_id?: number
}) =>
  $http.get({
    url: '/goods-google-structured-data',
    params,
    server: true,
    loading: false
  }).then((r: any) => r?.data)
